"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.basicBotTemplates = void 0;
const templateNames_1 = require("../templateNames");
const notificationBotTemplates = [
    {
        id: "notification-http-trigger-ts",
        name: templateNames_1.TemplateNames.NotificationHttpTrigger,
        language: "typescript",
        description: "",
    },
    {
        id: "notification-http-trigger-js",
        name: templateNames_1.TemplateNames.NotificationHttpTrigger,
        language: "javascript",
        description: "",
    },
    {
        id: "notification-http-trigger-csharp",
        name: templateNames_1.TemplateNames.NotificationHttpTrigger,
        language: "csharp",
        description: "",
    },
    {
        id: "notification-timer-trigger-ts",
        name: templateNames_1.TemplateNames.NotificationTimerTrigger,
        language: "typescript",
        description: "",
    },
    {
        id: "notification-timer-trigger-js",
        name: templateNames_1.TemplateNames.NotificationTimerTrigger,
        language: "javascript",
        description: "",
    },
    {
        id: "notification-timer-trigger-csharp",
        name: templateNames_1.TemplateNames.NotificationTimerTrigger,
        language: "csharp",
        description: "",
    },
    {
        id: "notification-http-timer-trigger-ts",
        name: templateNames_1.TemplateNames.NotificationHttpTimerTrigger,
        language: "typescript",
        description: "",
    },
    {
        id: "notification-http-timer-trigger-js",
        name: templateNames_1.TemplateNames.NotificationHttpTimerTrigger,
        language: "javascript",
        description: "",
    },
    {
        id: "notification-http-timer-trigger-csharp",
        name: templateNames_1.TemplateNames.NotificationHttpTimerTrigger,
        language: "csharp",
        description: "",
    },
    {
        id: "notification-express-ts",
        name: templateNames_1.TemplateNames.NotificationExpress,
        language: "typescript",
        description: "",
    },
    {
        id: "notification-express-js",
        name: templateNames_1.TemplateNames.NotificationExpress,
        language: "javascript",
        description: "",
    },
    {
        id: "notification-webapi-csharp",
        name: templateNames_1.TemplateNames.NotificationWebApi,
        language: "csharp",
        description: "",
    },
];
exports.basicBotTemplates = [
    {
        id: "default-bot-ts",
        name: templateNames_1.TemplateNames.DefaultBot,
        language: "typescript",
        description: "",
    },
    {
        id: "default-bot-js",
        name: templateNames_1.TemplateNames.DefaultBot,
        language: "javascript",
        description: "",
    },
    {
        id: "default-bot-csharp",
        name: templateNames_1.TemplateNames.DefaultBot,
        language: "csharp",
        description: "",
    },
    ...notificationBotTemplates,
    {
        id: "command-and-response-ts",
        name: templateNames_1.TemplateNames.CommandAndResponse,
        language: "typescript",
        description: "",
        link: "https://aka.ms/teamsfx-create-command",
    },
    {
        id: "command-and-response-js",
        name: templateNames_1.TemplateNames.CommandAndResponse,
        language: "javascript",
        description: "",
        link: "https://aka.ms/teamsfx-create-command",
    },
    {
        id: "command-and-response-csharp",
        name: templateNames_1.TemplateNames.CommandAndResponse,
        language: "csharp",
        description: "",
    },
    {
        id: "workflow-ts",
        name: templateNames_1.TemplateNames.Workflow,
        language: "typescript",
        description: "",
        link: "https://aka.ms/teamsfx-workflow-new",
    },
    {
        id: "workflow-js",
        name: templateNames_1.TemplateNames.Workflow,
        language: "javascript",
        description: "",
        link: "https://aka.ms/teamsfx-workflow-new",
    },
    {
        id: "workflow-csharp",
        name: templateNames_1.TemplateNames.Workflow,
        language: "csharp",
        description: "",
    },
];
//# sourceMappingURL=bot.js.map